import { render, staticRenderFns } from "./PreAndPostStockField.vue?vue&type=template&id=2e2361ca&scoped=true"
import script from "./PreAndPostStockField.vue?vue&type=script&lang=js"
export * from "./PreAndPostStockField.vue?vue&type=script&lang=js"
import style0 from "./PreAndPostStockField.vue?vue&type=style&index=0&id=2e2361ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2361ca",
  null
  
)

export default component.exports